import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DataPage.css';

import { API_URL } from '../config';

function Aparelhos() {
  const [aparelhos, setAparelhos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAparelhos();
  }, []);

  const fetchAparelhos = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/aparelhos`);
      setAparelhos(response.data || []);
    } catch (err) {
      console.error('Erro ao buscar aparelhos:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatarValor = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (value === 'T' || value === 't') return 'Sim';
    if (value === 'F' || value === 'f') return 'Não';
    return String(value);
  };

  if (loading) {
    return <div className="loading">Carregando aparelhos...</div>;
  }

  const styles = {
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '12px',
    },
    pageIcon: {
      fontSize: '1.5rem',
      lineHeight: 1,
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1a1a2e',
      margin: '0 0 2px 0',
    },
    pageSubtitle: {
      fontSize: '0.85rem',
      color: '#666',
      margin: 0,
    },
  };

  return (
    <div className="data-page">
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>⚙️</span>
          <div>
            <h1 style={styles.pageTitle}>Aparelhos</h1>
            <p style={styles.pageSubtitle}>Total: {aparelhos.length} aparelhos cadastrados</p>
          </div>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descrição</th>
              <th>Interface</th>
              <th>Prefixo</th>
              <th>Construído</th>
              <th>Exibe VR</th>
              <th>Usa Lista</th>
              <th>Atualizado</th>
              <th>Exportação</th>
            </tr>
          </thead>
          <tbody>
            {aparelhos.map((aparelho) => (
              <tr key={aparelho.ID}>
                <td><strong>{aparelho.ID}</strong></td>
                <td><strong>{aparelho.DESCRICAO}</strong></td>
                <td>{formatarValor(aparelho.INTERFACE)}</td>
                <td>{formatarValor(aparelho.PREFIXO_OBJETOS)}</td>
                <td>{formatarValor(aparelho.CONSTRUIDO)}</td>
                <td>{formatarValor(aparelho.EXIBE_COLUNA_VR)}</td>
                <td>{formatarValor(aparelho.USA_LISTA)}</td>
                <td>{formatarValor(aparelho.ATUALIZADO)}</td>
                <td>{formatarValor(aparelho.EXPORTACAO)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {aparelhos.length === 0 && !loading && (
        <div className="no-data">
          <p>Nenhum aparelho encontrado.</p>
        </div>
      )}
    </div>
  );
}

export default Aparelhos;
